import AutocompleteLocations from './AutocompleteLocations';

export default AutocompleteLocations;
